import { Backdrop, Box, Grid } from "@material-ui/core";
import { OrderProcessStatus } from "@saleor/apps/components/OrderProcessing";
import { isStaffRole } from "@saleor/auth/hooks/useUserRole";
import AtpCtpDialog from "@saleor/changeOrder/components/AtpCtpDialogChangeOrderExport";
import OrderBeingProcessError from "@saleor/changeOrder/components/OrderBeingProcessError";
import DialogConfirmCancelItem from "@saleor/changeOrderDomestic/components/DialogConfirmCancelItem";
import AddNewItem from "@saleor/changeOrderExport/components/AddNewItem";
import AgencyTabContent from "@saleor/changeOrderExport/components/AgencyTab";
import ChangeOrderFooter from "@saleor/changeOrderExport/components/ChangeOrderFooter";
import DialogConfirmChangeOrder from "@saleor/changeOrderExport/components/DialogConfirmChangeOrder";
import DialogSubmitOrder from "@saleor/changeOrderExport/components/DialogSubmitOrder";
import MaterialItemTabDetail from "@saleor/changeOrderExport/components/MaterialItemTab/Detail";
import MaterialItemTabEdit from "@saleor/changeOrderExport/components/MaterialItemTab/Edit";
import { DATA_CHOICE } from "@saleor/changeOrderExport/components/ModalInputParameter";
import OrderHeaderTab from "@saleor/changeOrderExport/components/OrderHeaderTab";
import { getInitHeaderValue } from "@saleor/changeOrderExport/components/OrderHeaderTab/formik";
import OrderProcessError from "@saleor/changeOrderExport/components/OrderProcessError";
import { viewEditOrderParamUrl } from "@saleor/changeOrderExport/urls";
import {
  ChangeOrderTab,
  conditionGroupOptions,
  TypeBlock,
  TypeConfirm,
  TypeOfAddProd,
  TypeSubmit,
  ViewEditMode
} from "@saleor/changeOrderExport/views/ViewEditOrder/types";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import CreditBlockDialog from "@saleor/components/CreditBlockDialog";
import CustomerBlockDialog from "@saleor/components/CustomerBlockDialog";
import DialogConfirm from "@saleor/components/DialogConfirm";
import DialogConfirmError from "@saleor/components/DialogConfirmError";
import DialogProcessing from "@saleor/components/DialogProcessing/DialogProcessing";
import MyTypography from "@saleor/components/MyTypography";
import PageHeader from "@saleor/components/PageHeader";
import Skeleton from "@saleor/components/Skeleton";
import SnackbarAlert from "@saleor/components/SnackbarAlert";
import { Tab, TabContainer } from "@saleor/components/Tab";
import TimeOutPage from "@saleor/components/TimeOutPage";
import { defaultListSettings } from "@saleor/config";
import DialogCreateOrderError from "@saleor/createOrder/components/DialogCreateOrderError";
import InvalidModal from "@saleor/createOrder/components/InvalidModal";
import { orderCartPath } from "@saleor/createOrder/urls";
import DialogError from "@saleor/createOrderExport/components/DialogError";
import DrawAddProduct from "@saleor/createOrderExport/components/DrawAddProduct";
import { DrawAddExportType } from "@saleor/createOrderExport/const";
import {
  ExportOrderQueryParams,
  ExportOrderSortField
} from "@saleor/createOrderExport/urls";
import {
  ChangeExportOrderLineAddProductInput,
  ChangeExportRejectReason,
  EditExportOrderInput,
  EditOrderItemInput,
  InquiryMethodType,
  ScgExportRejectReason,
  ScgpExportErrorCode,
  useAddProductsToChangeExportOrderMutation,
  useCancelDeleteExportOrderMutation,
  useCheckContractExpiredCompleteInvalidMutation,
  useContractExportOrderAllItemBySoNoQuery,
  useDuplicateOrderMutation,
  useEditOrderExportMutation,
  useExportChangeOrderAddNewOrderLineMutation,
  useExportOrderAtpCtpConfirmMutation,
  useGetCreditLimitQuery,
  useGetCustomerBlockQuery,
  useShowAtpCtpPopupLazyQuery,
  useUndoOrderLinesExportMutation
} from "@saleor/graphql";
import useAppState from "@saleor/hooks/useAppState";
import useBulkActions from "@saleor/hooks/useBulkActions";
import useListSettings from "@saleor/hooks/useListSettings";
import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import usePaginationLocal from "@saleor/hooks/usePaginationLocal";
import { makeStyles } from "@saleor/macaw-ui";
import { ListViews } from "@saleor/types";
import { convertValueObjectToNull } from "@saleor/utils/data/convertValueObjectToNull";
import { getIPlanMessagesCancelItem } from "@saleor/utils/message";
import {
  calculateNewTotalWeight,
  calculateTheWeight
} from "@saleor/utils/number";
import { getSortParams, getSortUrlVariables } from "@saleor/utils/sort";
import cls from "classnames";
import isEqual from "lodash/isEqual";
import moment from "moment";
import React, { ReactNode, useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";
import { useHistory, useLocation } from "react-router";

export interface ViewEditProps {
  id: string;
  params: ExportOrderQueryParams;
}

interface StyleProps {
  fullScreen?: boolean;
}

interface ModalConfirm {
  title: ReactNode | string;
  content: ReactNode | string;
  type: TypeConfirm;
  okText?: string;
  cancelText?: string;
  itemNo?: string;
}

export interface IListMaterial {
  conditionGroup1?: string;
  itemRemain: string;
  id?: string;
  itemNo: string;
  material: string;
  materialDesc: string;
  itemQty: string;
  salesUnit: string;
  plant: string;
  paymentTerm: string;
  poNumber: string;
  itemCategory: string;
  materialGroup1: string;
  saleText1Th: string;
  routeId: string;
  routeName: string;
  requestDate: string;
  untimatedTol: string;
  weightPerUnit: string;
  orderQty: string;
  comfirmQty: string;
  deliveryQty: string;
  deliveryStatus: string;
  saleQtyDivision: string;
  saleQtyFactor: string;
  prdHierachy: string;
  shippingPoint: string;
  contractNo: string;
  contractItemNo: string;
  atp: string;
  atpDetails: string;
  block: string;
  run: string;
  paperMachine: string;
  conditionUnit?: string;
  conditionRate?: string;
  confirmDate?: string;
  commission?: string;
  commissionAmount?: string;
  commissionUnit?: string;
  remark?: string;
  rollDiameter?: string;
  rollCoreDiameter?: string;
  noOfRoll?: string;
  reamRollPerPallet?: string;
  palletSize?: string;
  palletNo?: string;
  noOfPackage?: string;
  packingList?: string;
  reasonForReject?: string;
  unlimited?: string;
  errorDate?: boolean;
  isChange?: boolean;
  orderNo?: string;
  quantity?: string;
  deliveryTolUnder?: number;
  deliveryTolOver?: number;
  rejectReason?: ScgExportRejectReason;
  refPiNo?: string;
  refPiStock?: string;
  deliveryTolUnlimited?: boolean;
  route?: string;
  weightUnit?: string;
  isAddNew?: boolean;
  isDelete?: boolean;
  rollQuantity?: string;
  inquiryMethod?: string;
  flagR5?: boolean;
}

const AgencyTab = Tab(ChangeOrderTab.agency);
const HeaderTab = Tab(ChangeOrderTab.orderHeader);
const MaterialTab = Tab(ChangeOrderTab.materialItem);
const AddNewItemTab = Tab(ChangeOrderTab.addNewItem);

const useStyles = makeStyles<StyleProps>(
  theme => ({
    pageHeader: {
      marginBottom: "1.2rem",
      "& > :first-child": {
        visibility: props => (props.fullScreen ? "hidden" : "visible"),
        margin: 0,
        marginBottom: props => (props.fullScreen ? "0.4rem" : "1.2rem")
      },
      "& > :nth-child(2)": {
        alignSelf: "flex-end"
      }
    },
    boxContainer: {
      paddingBottom: "20rem"
    },
    tab: {
      padding: "10px 0",
      textAlign: "center"
    },
    tabBox: {
      "&>span:first-child": {
        borderRadius: "12px 0 0 0"
      },
      "&>span:last-child": {
        borderRadius: "0 12px 0 0"
      }
    },
    snackHeadTitle: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      columnGap: "1.2rem"
    },
    flex: {
      display: "flex"
    },
    subTitle: {
      display: "flex",
      alignItems: "center",
      marginBottom: "1.7rem",
      marginLeft: "2.5rem"
    },
    backDrop: {
      zIndex: 1399
    },
    boxInfo: {
      marginTop: "3rem"
    },
    SoNo: {
      color: theme.palette.info.main
    },
    popUpInlineBlock: {
      display: "inline-block",
      color: theme.palette.grey[900]
    }
  }),
  { name: "OrdersView" }
);

const ViewEditOrdersView: React.FC<ViewEditProps> = ({ id, params }) => {
  const intl = useIntl();
  const navigate = useNavigator();
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);

  const notify = useNotifier();

  const [{ fullScreen, viewEditMode }, dispatchAppState] = useAppState();
  const classes = useStyles({ fullScreen });
  const [activeTab, setActiveTab] = useState<ChangeOrderTab>(
    params.tab || ChangeOrderTab.agency
  );
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [isSuccessfully, setSuccessfully] = useState<TypeOfAddProd | null>(
    null
  );
  const [componentKey, setComponentKey] = useState<number>(0);
  const [drawKey, setDrawKey] = useState<number>(0);
  const [openConfirmOrder, setOpenConfirmOrder] = useState<boolean>(false);
  const [submitOrderCall, setSubmitOrderCall] = useState<number>(0);
  const [addItemSubmited, setAddItemSubmited] = useState<number>(0);
  const [valueConfirmHeader, setValueConfirmHeader] = useState(null);
  const [valueConfirmMaterial, setValueConfirmMaterial] = useState(null);
  const [dataOrderHeader, setDataOrderHeader] = useState({});
  const [dataOrderHeaderRoot, setDataOrderHeaderRoot] = useState({});
  const [billToInsteaded, setBillToInsteaded] = useState<string>("");
  const [shipToInsteaded, setShipToInsteaded] = useState<string>("");
  const [dataModalConfirm, setDataModalConfirm] = useState<ModalConfirm>({
    type: undefined,
    content: undefined,
    title: undefined
  });
  const [isOpenCancelEdit, setIsOpenCancelEdit] = useState<boolean>(false);
  const [isOpenInvalidOrderError, setIsOpenInvalidOrderError] = useState<
    boolean
  >(false);
  const [listMaterial, setListMaterial] = useState<IListMaterial[]>([]);
  const [openDialogProcessing, setOpenDialogProcessing] = useState<boolean>(
    false
  );
  const [openError, setOpenError] = useState<boolean>(false);
  const [openCreateOrderError, setOpenCreateOrderError] = useState<boolean>(
    false
  );
  const [openR5ErrorPopup, setOpenR5ErrorPopup] = useState<boolean>(false);

  const [itemErrors, setItemErrors] = useState<string[]>([]);
  const [itemErrorsR5, setItemErrorsR5] = useState<string[]>([]);
  const [openGLDateErrorPopup, setOpenGLDateErrorPopup] = useState<boolean>(
    false
  );
  const [openDialogAtpCtpError, setOpenDialogAtpCtpError] = useState<boolean>(
    false
  );
  const [openDrawATP, setOpenDrawATP] = useState<boolean>(false);
  const [dataDrawATP, setDataOpenATP] = useState<IListMaterial[]>([]);
  const [openCustomerBlock, setOpenCustomerBlock] = useState<boolean>(false);
  const [openCreditBlock, setOpenCreditBlock] = useState<boolean>(false);

  const [isDisapearItem, setIsDisapearItem] = useState<boolean>(false);
  const [orderProcessError, setOrderProcessError] = useState("");
  const [orderProcessErrorDialog, setOrderProcessErrorDialog] = useState(false);
  const [openDialogCancelDelete, setOpenDialogCancelDelete] = useState<boolean>(
    false
  );
  const [openCancelAddNewItem, setOpenCancelAddNewItem] = useState<boolean>(
    false
  );
  const [openConfirmAddNewItem, setOpenConfirmAddNewItem] = useState<boolean>(
    false
  );
  const [cancelEditCall, setCancelEditCall] = useState<number>(0);
  const [contentCustomerBlock, setContentCustomerBlock] = useState<string>("");
  const [typeBlock, setTypeBlock] = useState<TypeBlock>(TypeBlock.BLOCK_EDIT);

  const [dialogError, setDialogError] = useState(false);
  const [errorSource, setErrorSource] = useState("");
  const [errorOrders, setErrorOrders] = useState([]);
  const [errorItems, setErrorItems] = useState([]);

  const [popUpContent, setPopUpContent] = useState(null);

  const [orderProcessStatus, setOrderProcessStatus] = useState<
    OrderProcessStatus
  >(OrderProcessStatus.inconclusive);
  const [beingProcessMsg, setBeingProcessMsg] = useState<string>("");

  const {
    data: exportOrder,
    loading: loadingChangeOrder,
    refetch: refetchDataExport
  } = useContractExportOrderAllItemBySoNoQuery({
    variables: {
      soNo: id
    }
  });

  const [
    checkContractExpiredCompleteInvalid,
    { data: dataCheckContractExpiredCompleteInvalid }
  ] = useCheckContractExpiredCompleteInvalidMutation({
    variables: {
      contractNo: exportOrder?.exportOrderWithAllItemsBySoNo?.contractNo
    }
  });

  const [
    callAddNewOrderLine,
    { loading: loadingAddNewItem }
  ] = useExportChangeOrderAddNewOrderLineMutation({
    onError: error => {
      if (error?.message?.includes("Read timed out")) {
        setOrderProcessStatus(OrderProcessStatus.timeOut);
        return;
      }
      if (error.message === "Network request failed") {
        setOrderProcessError("400");
      } else {
        setOrderProcessError(error.message);
      }
      setOpenDialogProcessing(false);
    },
    onCompleted: data => {
      setOpenDialogProcessing(false);

      if (!data.exportChangeOrderAddNewOrderLines.success) {
        if (
          data?.exportChangeOrderAddNewOrderLines?.sapOrderMessages?.length >
            0 ||
          data?.exportChangeOrderAddNewOrderLines?.sapItemMessages?.length > 0
        ) {
          const sapErrorOrders =
            data?.exportChangeOrderAddNewOrderLines?.sapOrderMessages?.map(
              ({ errorCode, errorMessage }) => `${errorCode} - ${errorMessage}`
            ) || [];

          const sapErrorItems =
            data?.exportChangeOrderAddNewOrderLines?.sapItemMessages?.map(
              ({ itemNo, errorMessage, errorCode }) => ({
                itemNo,
                itemCode: `${errorCode || ""}`,
                itemStatus: errorMessage
              })
            ) || [];

          setDialogError(true);
          setErrorSource("SAP");
          setErrorOrders(sapErrorOrders);
          setErrorItems(sapErrorItems);
        }

        if (
          data?.exportChangeOrderAddNewOrderLines?.iPlanMessages?.length > 0
        ) {
          const iplanErrorItems = data?.exportChangeOrderAddNewOrderLines?.iPlanMessages?.map(
            item => ({
              itemNo: item.itemNo,
              itemCode: `${item.firstCode}${item.secondCode}`,
              itemStatus: item.message
            })
          );

          setDialogError(true);
          setErrorSource("IPLAN");
          setErrorItems(iplanErrorItems);
        }
      } else {
        queryParams.delete("mode");
        // queryParams.append("mode", "edit");
        history.replace({
          search: queryParams.toString()
        });
        setActiveTab(ChangeOrderTab.materialItem);
        setViewEditMode(ViewEditMode.VIEW);
        refetchDataExport();
      }
    }
  });

  const handleSubmitAddNewItem = () => {
    // setOrderProcessStatus(OrderProcessStatus.success);
    setAddItemSubmited(1);
    setOpenConfirmAddNewItem(false);
  };

  const handleUpdateNewItem = error => {
    if (!error) {
      setOpenDialogProcessing(true);
      callAddNewOrderLine({
        variables: {
          id: exportOrder?.exportOrderWithAllItemsBySoNo?.eoNo,
          input: {
            orderHeader: {
              piNo: exportOrder?.exportOrderWithAllItemsBySoNo?.contractNo,
              eoNo: exportOrder?.exportOrderWithAllItemsBySoNo?.eoNo,
              soldTo: getSoldToText(),
              billTo: billToInsteaded.split("\n")[0] || getBillToPartyName(),
              shipTo: shipToInsteaded.split("\n")[0] || getShipToPartyName()
            },
            line: listMaterial
              .filter(item => item.isAddNew)
              .map(line => ({
                //
                id: line.id,
                materialCode: line.material,
                itemNo: String(line.itemNo),
                quantity: Number(line.quantity),
                quantityUnit: line.conditionUnit,
                weightUnit: line.weightPerUnit,
                weight: Number(line.weightPerUnit) || 0,
                itemCatEo: line.itemCategory,
                plant: line.plant,
                refPiNo: String(line.refPiNo),
                requestDate: line.requestDate,
                route: line.route,
                deliveryTolUnder: line.deliveryTolUnder,
                deliveryTolOver: line.deliveryTolOver,
                deliveryTolUnlimited: line.deliveryTolUnlimited,
                rollDiameter: line.rollDiameter,
                rollCoreDiameter: line.rollCoreDiameter,
                rollQuantity: line.rollQuantity,
                rollPerPallet: line.reamRollPerPallet,
                palletSize: line.palletSize,
                palletNo: line.palletNo,
                packageQuantity: line.noOfPackage,
                packingList: line.packingList,
                shippingPoint: line.shippingPoint,
                remark: null,
                shippingMark: line.remark,
                rejectReason: line.rejectReason as ScgExportRejectReason,
                inquiryMethod: converValueInquiryToEnum(line.inquiryMethod)
              }))
          }
        }
      });
    } else {
      setOpenError(true);
    }

    setAddItemSubmited(0);
  };

  const handleCancelAddNewItem = () => {
    const newListOrderLine = [...listMaterial.filter(line => !line.isAddNew)];
    newListOrderLine.sort(
      (itemA: any, itemB: any) => itemA.itemNo - itemB.itemNo
    );
    setListMaterial(newListOrderLine);
    // navigate(
    //   changeOrderPathUrl(id, {
    //     ...params,
    //     editMode: ViewEditMode.VIEW,
    //     sort: DomesticOrderSortField.item_no,
    //     asc: true
    //   }),
    //   { replace: true }
    // );
    setOpenCancelAddNewItem(false);
    queryParams.delete("mode");
    history.replace({
      search: queryParams.toString()
    });
    setViewEditMode(ViewEditMode.VIEW);
  };

  const toggleCreditBlock = () => {
    setOpenCreditBlock(prev => !prev);
  };

  const toggleCustomerBlock = () => {
    setOpenCustomerBlock(prev => !prev);
  };

  const bulkActions = useBulkActions([]);

  const isStaff = isStaffRole();

  const { listElements, reset } = bulkActions;

  const handleOpenATP = () => {
    const atpItem = listElements.filter(
      item => !itemErrors?.includes(item) && !itemErrorsR5.includes(item)
    );

    const dataATP = atpItem?.map(item =>
      listMaterial.find(line => line.itemNo === item)
    );

    setOpenDrawATP(true);
    setDataOpenATP(dataATP);
  };

  const [checkStatusAtpCtp] = useShowAtpCtpPopupLazyQuery({
    onCompleted(data) {
      if (data?.showAtpCtpPopup?.flag === "gidate") {
        setItemErrors(data.showAtpCtpPopup.itemErrors);
        setOpenGLDateErrorPopup(true);
      } else if (data?.showAtpCtpPopup?.flag === "status") {
        setItemErrors(data.showAtpCtpPopup.itemErrors);
        setOpenDialogAtpCtpError(true);
      } else {
        setItemErrors([]);
        handleOpenATP();
      }
    },
    fetchPolicy: "no-cache"
  });

  const handleClickAtpCtp = () => {
    const lineIds = [];
    const itemNoR5 = [];
    const data = listMaterial.filter(item =>
      listElements.includes(item.itemNo)
    );
    data.forEach(item => {
      if (item.flagR5) {
        itemNoR5.push(item.itemNo);
      } else {
        lineIds.push(item.id);
      }
    });

    if (itemNoR5.length) {
      setItemErrorsR5(itemNoR5);
      setOpenR5ErrorPopup(true);
    } else {
      checkStatusAtpCtp({
        variables: {
          lineIds
        }
      });
    }
  };

  const toggleCloseCreateOrderError = () => {
    setOpenCreateOrderError(val => !val);
  };
  const { updateListSettings, settings } = useListSettings(
    ListViews.EDIT_ORDER
  );

  useEffect(() => {
    updateListSettings("rowNumber", defaultListSettings.EDIT_ORDER.rowNumber);
    return () => {
      if (params.mode === "add") {
        setViewEditMode(ViewEditMode.VIEW);
        queryParams.delete("mode");
        history.replace({
          search: queryParams.toString()
        });
      }
    };
  }, []);

  const [
    SubmitExportOrder,
    { loading: loadingSubmitOrder }
  ] = useEditOrderExportMutation({
    onCompleted: data => {
      setOpenDialogProcessing(false);
      setValueConfirmMaterial(null);
      setValueConfirmHeader(null);

      if (!data?.editOrderExport?.success) {
        if (
          data?.editOrderExport?.sapOrderMessages?.length > 0 ||
          data?.editOrderExport?.sapItemMessages?.length > 0
        ) {
          const sapErrorOrders = data?.editOrderExport?.sapOrderMessages?.map(
            ({ errorCode, errorMessage }) => `${errorCode} - ${errorMessage}`
          );

          const sapErrorItems = data?.editOrderExport?.sapItemMessages?.map(
            ({ itemNo, errorCode, errorMessage }) => ({
              itemNo,
              itemCode: errorCode,
              itemStatus: errorMessage
            })
          );

          setDialogError(true);
          setErrorSource("SAP");
          setErrorOrders(sapErrorOrders);
          setErrorItems(sapErrorItems);
        } else if (data?.editOrderExport?.iplanMessages?.length > 0) {
          const iplanErrorItems = data?.editOrderExport?.iplanMessages?.map(
            item => ({
              itemNo: item.itemNo,
              itemCode: `${item.firstCode}${item.secondCode}`,
              itemStatus: item.message
            })
          );

          setDialogError(true);
          setErrorSource("IPLAN");
          setErrorItems(iplanErrorItems);
        } else {
          let sapOrderErrors = "";
          // eslint-disable-next-line chai-friendly/no-unused-expressions
          data?.editOrderExport?.errors.length &&
            data?.editOrderExport?.errors?.forEach(({ message }) => {
              sapOrderErrors += `${message} \n`;
            });

          notify({
            status: "error",
            apiMessage: sapOrderErrors
          });
        }
      } else {
        if (data?.editOrderExport?.iplanMessages?.length > 0) {
          const iplanErrList = data?.editOrderExport?.iplanMessages?.map(
            item => `${item.firstCode}${item.secondCode} - ${item.message}`
          );

          notify({
            status: "error",
            sourceSystem: "IPLAN",
            apiMessage: iplanErrList.join("\n")
          });
        }

        refetchDataExport();
        setActiveTab(ChangeOrderTab.agency);
        setViewEditMode(ViewEditMode.VIEW);
        queryParams.delete("mode");
        history.replace({
          search: queryParams.toString()
        });
        dispatchAppState({
          payload: {
            tabMaterial: 0
          },
          type: "setTabMaterial"
        });

        if (data?.editOrderExport?.sapWarningMessages?.length > 0) {
          notify({
            title: "Warning",
            status: "warning",
            apiMessage: data?.editOrderExport?.sapWarningMessages
              ?.map(item => `${item.order} - ${item.message}`)
              .join("\n"),
            autohide: null
          });
        }
      }
    },
    onError: error => {
      if (error?.message?.includes("Read timed out")) {
        setOrderProcessStatus(OrderProcessStatus.timeOut);
        return;
      }
      setOpenDialogProcessing(false);
      setOrderProcessErrorDialog(true);

      if (error.message === "Network request failed") {
        setOrderProcessError("400");
      } else {
        setOrderProcessError(error.message);
      }
    }
  });

  useEffect(() => {
    if (viewEditMode === ViewEditMode.EDIT && !queryParams.has("mode")) {
      queryParams.append("mode", "edit");
      history.replace({
        search: queryParams.toString()
      });
    }
    if (viewEditMode === ViewEditMode.ADD && !queryParams.has("mode")) {
      queryParams.append("mode", "add");
      history.replace({
        search: queryParams.toString()
      });
    }
    // if (viewEditMode === ViewEditMode.VIEW && queryParams.has("mode")) {
    //   queryParams.delete("mode");
    //   history.replace({
    //     search: queryParams.toString()
    //   });
    // }
  }, [viewEditMode]);

  const isDisableEditOrder = useMemo(
    () =>
      exportOrder?.exportOrderWithAllItemsBySoNo?.orderStatus ===
        "Completed Delivery" ||
      exportOrder?.exportOrderWithAllItemsBySoNo?.orderStatus ===
        "Complete Order" ||
      exportOrder?.exportOrderWithAllItemsBySoNo?.orderStatus ===
        "Completed Order",
    [exportOrder?.exportOrderWithAllItemsBySoNo?.orderStatus]
  );

  useEffect(() => {
    if (
      !isDisableEditOrder &&
      exportOrder?.exportOrderWithAllItemsBySoNo?.orderStatus
    ) {
      if (params?.mode === "edit") {
        dispatchAppState({
          type: "setViewEditMode",
          payload: {
            viewEditMode: ViewEditMode.EDIT
          }
        });
      } else if (params?.mode === "add") {
        dispatchAppState({
          type: "setViewEditMode",
          payload: {
            viewEditMode: ViewEditMode.ADD
          }
        });
      } else {
        dispatchAppState({
          type: "setViewEditMode",
          payload: {
            viewEditMode: ViewEditMode.VIEW
          }
        });
      }
    }
  }, [
    params?.mode,
    isDisableEditOrder,
    exportOrder?.exportOrderWithAllItemsBySoNo?.orderStatus
  ]);

  const setViewEditMode = (mode: ViewEditMode) => {
    // if (!queryParams.has("mode")) {
    //   queryParams.append("mode", "edit");
    //   history.replace({
    //     search: queryParams.toString()
    //   });
    // }
    dispatchAppState({
      type: "setViewEditMode",
      payload: {
        viewEditMode: mode
      }
    });
  };

  const resetPaginationState = () => {
    setComponentKey(componentKey + 1);
    toFirst();
  };

  const [
    acceptAtpItem,
    { loading: loadingAtpCtp }
  ] = useExportOrderAtpCtpConfirmMutation({
    onCompleted(data) {
      if (
        !data?.exportOrderAtpCtpConfirm?.errors?.length &&
        !data?.exportOrderAtpCtpConfirm?.sapOrderErrorMessages?.length &&
        !data?.exportOrderAtpCtpConfirm?.iPlanErrorMessages?.length &&
        !data?.exportOrderAtpCtpConfirm?.sapItemMessages?.length
      ) {
        setIsDisapearItem(true);
        refetchDataExport().then(() => {
          setViewEditMode(ViewEditMode.EDIT);
        });
        setTimeout(() => {
          setIsDisapearItem(false);
        }, 1000);
      } else {
        if (data?.exportOrderAtpCtpConfirm?.errors?.length > 0) {
          notify({
            status: "error",
            sourceSystem: "Eordering",
            apiMessage: data?.exportOrderAtpCtpConfirm?.errors
              ?.map(item => `${item.code} - ${item.message}`)
              .join("\n")
          });
          return;
        }

        if (data?.exportOrderAtpCtpConfirm?.iPlanErrorMessages.length > 0) {
          notify({
            status: "error",
            sourceSystem: "Iplan",
            apiMessage: data?.exportOrderAtpCtpConfirm?.iPlanErrorMessages
              ?.map(
                item => `${item.firstCode}${item.secondCode} - ${item.message}`
              )
              .join("\n")
          });
          return;
        }

        if (data?.exportOrderAtpCtpConfirm?.sapOrderErrorMessages?.length > 0) {
          notify({
            status: "error",
            sourceSystem: "SAP",
            apiMessage: data?.exportOrderAtpCtpConfirm?.sapOrderErrorMessages
              ?.map(item => `${item.errorCode} - ${item.errorMessage}`)
              .join("\n")
          });
          return;
        }
        if (data?.exportOrderAtpCtpConfirm?.sapItemMessages?.length > 0) {
          notify({
            status: "error",
            sourceSystem: "SAP",
            apiMessage: data?.exportOrderAtpCtpConfirm?.sapItemMessages
              ?.map(
                item =>
                  `${item.itemNo || ""} ${item.errorCode || ""} - ${
                    item.errorMessage
                  }`
              )
              .join("\n")
          });
          return;
        }
      }
    }
  });

  const getConditionUnitByItemNo = (_itemNo: string) =>
    exportOrder?.exportOrderWithAllItemsBySoNo?.orderCondition?.find(
      order =>
        Number(order?.itemNo) === Number(_itemNo) &&
        (order?.conditionType === "ZPR2" || order?.conditionType === "ZPR3")
    )?.conditionUnit || "";

  const getConditionRateByItemNo = (_itemNo: string) =>
    exportOrder?.exportOrderWithAllItemsBySoNo?.orderCondition?.find(
      order =>
        Number(order?.itemNo) === Number(_itemNo) &&
        (order?.conditionType === "ZPR2" || order?.conditionType === "ZPR3")
    )?.conditionRate || "";

  const getCommissionByItemNo = (_itemNo: string) =>
    exportOrder?.exportOrderWithAllItemsBySoNo?.orderCondition?.find(
      order => +order?.itemNo === +_itemNo && order?.conditionType === "ZCM1"
    )?.conditionRate || "";

  const getCommissionAmountByItemNo = (_itemNo: string) =>
    exportOrder?.exportOrderWithAllItemsBySoNo?.orderCondition?.find(
      order => +order?.itemNo === +_itemNo && order?.conditionType === "ZCM3"
    )?.conditionRate || "";

  const getCommissionUnitByItemNo = (_itemNo: string) =>
    exportOrder?.exportOrderWithAllItemsBySoNo?.orderCondition?.find(
      order => +order?.itemNo === +_itemNo && order?.conditionType === "ZCM3"
    )?.currency || "";

  const getDataOrderTextByCodeAndItemNo = (code, itemNo) => {
    const _item = exportOrder?.exportOrderWithAllItemsBySoNo?.orderText?.find(
      item => item?.textId === code && +item?.itemNo === +itemNo
    );
    let _text = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    _item?.textLine?.forEach(text =>
      _text === "" ? (_text += text.text) : (_text += `\n${text.text}`)
    );
    return _text;
  };

  const getRemarkByItemNo = (_itemNo: string) =>
    getDataOrderTextByCodeAndItemNo("Z004", _itemNo);

  const getRollDiameterByItemNo = (_itemNo: string) =>
    getDataOrderTextByCodeAndItemNo("Z008", _itemNo);

  const getRollCoreDiameterByItemNo = (_itemNo: string) =>
    getDataOrderTextByCodeAndItemNo("Z009", _itemNo);

  const getNoOfRollByItemNo = (_itemNo: string) =>
    getDataOrderTextByCodeAndItemNo("Z003", _itemNo);

  const getReamRollPerPallet = (_itemNo: string) =>
    getDataOrderTextByCodeAndItemNo("Z011", _itemNo);

  const getPalletSize = (_itemNo: string) =>
    getDataOrderTextByCodeAndItemNo("Z010", _itemNo);

  const getPalletNo = (_itemNo: string) =>
    getDataOrderTextByCodeAndItemNo("Z005", _itemNo);

  const getNoOfPackage = (_itemNo: string) =>
    getDataOrderTextByCodeAndItemNo("Z006", _itemNo);

  const getPackingList = (_itemNo: string) =>
    getDataOrderTextByCodeAndItemNo("Z017", _itemNo);

  const getRoute = _item => {
    if (!_item.routeId && !_item.routeName) {
      return "";
    } else {
      return `${_item?.routeId || ""} - ${_item?.routeName || ""}`;
    }
  };

  const getReasonReject = _item => {
    if (_item.reasonReject) {
      if (_item.reasonReject === "93") {
        return ScgExportRejectReason.YES;
      } else {
        return ScgExportRejectReason.NO;
      }
    }
    return ScgExportRejectReason.NO;
  };
  const formatMaterialGroup = item => {
    if (item.materialGroup1?.includes("K01")) {
      return "K01 - Kraft Roll";
    } else if (item.materialGroup1?.includes("K09")) {
      return "K09 - Gypsum";
    } else {
      return item.materialGroup1;
    }
  };

  const formatConditionGroup = item =>
    conditionGroupOptions.find(option => option === item.conditionGroup1) ||
    item.conditionGroup1;

  const getItemRemain = (listItem, item) => {
    const listSameMatCode = listItem.filter(
      itemInList => itemInList.material === item.material
    );
    const totalMaterial = listSameMatCode.reduce(
      (totalQuantity, itemReduce) => (totalQuantity += +itemReduce.orderQty),
      0
    );
    if (isContainer(item)) {
      return +item.remainingQuantityEx + totalMaterial;
    }
    return (
      +item.remainingQuantityEx / (+item.saleQtyFactor / 1000) + totalMaterial
    );
  };
  const isContainer = item => item?.itemCategory === "ZKC0";

  const isK01K09 = item =>
    item.materialGroup1?.includes("K01") ||
    item.materialGroup1?.includes("K09") ||
    item.materialGroup2?.includes("K01") ||
    item.materialGroup2?.includes("K09");

  useEffect(() => {
    if ((exportOrder && !loadingChangeOrder) || cancelEditCall) {
      const _listMaterial = exportOrder?.exportOrderWithAllItemsBySoNo
        ?.orderItems?.length
        ? [...exportOrder.exportOrderWithAllItemsBySoNo.orderItems].map(
            item => ({
              ...item,
              itemRemain: getItemRemain(
                exportOrder.exportOrderWithAllItemsBySoNo.orderItems,
                item
              ),
              quantity: item.itemQty?.toString() || "",
              originQuantity: item.itemQty?.toString() || "",
              conditionUnit: getConditionUnitByItemNo(item.itemNo),
              conditionRate: getConditionRateByItemNo(item.itemNo),
              commission: getCommissionByItemNo(item.itemNo),
              commissionAmount: getCommissionAmountByItemNo(item.itemNo),
              commissionUnit: getCommissionUnitByItemNo(item.itemNo),
              confirmDate: item?.confirmedDate,
              remark: getRemarkByItemNo(item.itemNo),
              rollDiameter: getRollDiameterByItemNo(item.itemNo),
              rollCoreDiameter: getRollCoreDiameterByItemNo(item.itemNo),
              rollQuantity: getNoOfRollByItemNo(item.itemNo),
              reamRollPerPallet: getReamRollPerPallet(item.itemNo),
              palletSize: getPalletSize(item.itemNo),
              palletNo: getPalletNo(item.itemNo),
              noOfPackage: getNoOfPackage(item.itemNo),
              packingList: getPackingList(item.itemNo),
              rejectReason: getReasonReject(item),
              weightPerUnit: item.weightPerUnit,
              weightUnit:
                getConditionUnitByItemNo(item.itemNo) === "ตัน"
                  ? "TON"
                  : getConditionUnitByItemNo(item.itemNo),
              weight: calculateNewTotalWeight(item.itemQty, item),
              packageQuantity: getNoOfPackage(item.itemNo),
              requestDate: item.requestedDate
                ? moment(item.requestedDate, "DD/MM/YYYY").format("YYYY-MM-DD")
                : "",
              deliveryTolUnlimited: !!item.untimatedTol,
              route: getRoute(item),
              isContainer: isContainer(item),
              isK01K09: isK01K09(item),
              materialGroup1: formatMaterialGroup(item),
              conditionGroup1: formatConditionGroup(item),
              writable: true,
              textErrorMessageQuantity: ""
            })
          )
        : [];
      setListMaterial(_listMaterial);
      checkContractExpiredCompleteInvalid();
    }
  }, [exportOrder, loadingChangeOrder, cancelEditCall]);

  const {
    currentData,
    next,
    prev,
    toFirst,
    toLast,
    disableNext,
    disablePrev
  } = usePaginationLocal(
    listMaterial.filter(item => !item.isDelete),
    settings.rowNumber
  );

  const onNextPage = () => {
    next();
    setComponentKey(componentKey + 1);
  };

  const onPrevPage = () => {
    prev();
    setComponentKey(componentKey + 1);
  };

  const onLastPage = () => {
    toLast();
    setComponentKey(componentKey + 1);
  };

  const onFirstPage = () => {
    toFirst();
    setComponentKey(componentKey + 1);
  };

  useEffect(() => {
    if (exportOrder && !loadingChangeOrder) {
      setComponentKey(componentKey + 1);
    }
  }, [exportOrder, loadingChangeOrder]);

  useEffect(() => {
    if (exportOrder && !loadingChangeOrder) {
      const initOrderHeader = getInitHeaderValue(
        exportOrder?.exportOrderWithAllItemsBySoNo
      );
      setDataOrderHeader(initOrderHeader);
      setDataOrderHeaderRoot(initOrderHeader);
    }
  }, [exportOrder, loadingChangeOrder]);

  const getSoldToCode = () => {
    let _soldToCode = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    exportOrder?.exportOrderWithAllItemsBySoNo?.orderPartners?.forEach(
      orderPartner => {
        if (orderPartner?.partnerRole === "AG") {
          _soldToCode = orderPartner?.partnerNo;
        }
      }
    );
    return _soldToCode;
  };
  const getSoldToName = () => {
    let _soldToCode = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    exportOrder?.exportOrderWithAllItemsBySoNo?.orderPartners?.forEach(
      orderPartner => {
        if (orderPartner?.partnerRole === "AG") {
          _soldToCode = orderPartner?.address[0].name;
        }
      }
    );
    return _soldToCode;
  };

  const handleSort = field => {
    resetPaginationState();
    const sortParam = getSortUrlVariables(field, params);
    const _listMaterial = [...listMaterial];
    switch (sortParam.sort) {
      case ExportOrderSortField.material_code:
        if (sortParam.asc) {
          _listMaterial.sort(
            (itemA: any, itemB: any) =>
              itemA.material.slice(itemA.material.length - 11) -
              itemB.material.slice(itemB.material.length - 11)
          );
        } else {
          _listMaterial.sort(
            (itemA: any, itemB: any) =>
              itemB.material.slice(itemB.material.length - 11) -
              itemA.material.slice(itemA.material.length - 11)
          );
        }
        break;
      case ExportOrderSortField.item_no:
        if (sortParam.asc) {
          _listMaterial.sort(
            (itemA: any, itemB: any) => itemA.itemNo - itemB.itemNo
          );
        } else {
          _listMaterial.sort(
            (itemA: any, itemB: any) => itemB.itemNo - itemA.itemNo
          );
        }
        break;
      default:
        break;
    }
    setListMaterial(_listMaterial);
    setComponentKey(componentKey + 1);
    navigate(
      viewEditOrderParamUrl(id, {
        ...params,
        ...sortParam
      }),
      { replace: true }
    );
  };

  const getTitle = () =>
    viewEditMode === ViewEditMode.VIEW
      ? intl.formatMessage({ defaultMessage: "Order Details" })
      : viewEditMode === ViewEditMode.ADD
      ? intl.formatMessage({ defaultMessage: "Add new items" })
      : intl.formatMessage({ defaultMessage: "Edit Order" });

  const handleBack = () => {
    setDataModalConfirm({
      content: intl.formatMessage({
        defaultMessage:
          "กรุณากด “ยืนยัน” เพื่อยกเลิกการแก้ไขคำสั่งซื้อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
      }),
      title: intl.formatMessage({ defaultMessage: "ยกเลิกการแก้ไขคำสั่งซื้อ" }),
      type: TypeConfirm.CANCEL
    });
    handleOpenConfirm();
  };

  const onTabClick = tab => {
    setActiveTab(tab);
  };

  // const getTotalPrice = () =>

  const totalPricePerUnit = useMemo(
    () =>
      listMaterial.reduce((store, line) => {
        if (line.isDelete) {
          return store;
        }
        if (!line?.conditionRate) {
          return store;
        }
        if (line.itemCategory === "ZTNN" || line.itemCategory === "ZTN1") {
          return store;
        }
        if (line.rejectReason === ScgExportRejectReason.YES) {
          return store;
        }

        const saleQtyFactor = line.saleQtyFactor;
        const priceEachItem =
          +line.conditionRate *
          calculateTheWeight(
            "TON",
            Number(saleQtyFactor),
            Number(line.quantity)
          );

        return (store += priceEachItem);
      }, 0),
    [listMaterial]
  );

  const priceData = {
    itemCount:
      exportOrder?.exportOrderWithAllItemsBySoNo?.orderItems?.length || 0,
    netPrice: totalPricePerUnit.toString(),
    vat: (
      totalPricePerUnit *
      Number(exportOrder?.exportOrderWithAllItemsBySoNo?.taxPercent || 0)
    ).toString(),
    totalPrice: (
      totalPricePerUnit +
      totalPricePerUnit *
        Number(exportOrder?.exportOrderWithAllItemsBySoNo?.taxPercent || 0)
    ).toString(),
    currency: exportOrder?.exportOrderWithAllItemsBySoNo?.docCurrency || ""
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const [handleAddProduct] = useAddProductsToChangeExportOrderMutation({
    onError: () => {
      setSuccessfully(TypeOfAddProd.UnSuccessfully);
    }
  });

  const calculateItemNoForNewLine = index => {
    const fixedItemNo =
      exportOrder?.exportOrderWithAllItemsBySoNo?.fixedItemNo?.map(
        item => +item
      ) || [];
    const listItemNo = listMaterial.map(item => +item.itemNo);
    const biggestItemNo = [...listItemNo, ...fixedItemNo].length
      ? Math.max(...listItemNo, ...fixedItemNo)
      : 0;
    return biggestItemNo + 10 * (index + 1);
  };

  const handleAddProductToExport = values => {
    const params: ChangeExportOrderLineAddProductInput[] = values.map(item => ({
      piProduct: item.id,
      quantity: item.quantity,
      orderlinesId: listMaterial.map(item => item.id).filter(item => item)
    }));
    handleAddProduct({
      variables: { id, input: params }
    }).then(response => {
      if (response?.data?.addProductsToChangeExportOrder?.result?.length) {
        const result: any[] =
          response?.data?.addProductsToChangeExportOrder?.result;
        const resultFormat = result.map((item, index) => {
          const materialAddInDraw = values.find(
            itemDraw => itemDraw.id === item.piProduct.id
          );

          const itemRemain =
            materialAddInDraw.salesUnit === "EA"
              ? materialAddInDraw.remainingQuantityEx
              : materialAddInDraw.remainingQuantityEx /
                materialAddInDraw.weight;
          return {
            ...item,
            itemNo: calculateItemNoForNewLine(index),
            isAddNew: true,
            isRequestDateChanged: false,
            material: item.materialCode,
            materialDesc: item.materialDescription,
            materialGroup1: item.materialGroup2,
            itemCategory: item.itemCatEo,
            refPiNo: Number(materialAddInDraw.itemNo),
            saleQtyFactor: item.weight * 1000,
            rejectReason: item.rejectReason?.toUpperCase(),
            conditionRate: item.piProduct?.pricePerUnit || 0,
            itemRemain,
            conditionGroup1: formatConditionGroup(item),
            isK01K09: isK01K09(item),
            isContainer: isContainer(item)
          };
        });
        const _newList = [...listMaterial];
        _newList.push(...resultFormat);
        _newList.sort((itemA: any, itemB: any) => itemB.itemNo - itemA.itemNo);
        setListMaterial(_newList);
        setComponentKey(prev => prev + 1);
        setSuccessfully(TypeOfAddProd.Successfully);
        setViewEditMode(ViewEditMode.ADD);
      } else if (
        response.data.addProductsToChangeExportOrder.errors[0].code ===
        ScgpExportErrorCode.PRODUCT_GROUP_ERROR
      ) {
        setPopUpContent(
          <MyTypography variant="body2" className={classes.popUpInlineBlock}>
            กรุณาเลือก{" "}
            <MyTypography
              variant="subtitle2"
              className={classes.popUpInlineBlock}
            >
              สินค้ากลุ่มเดียวกัน
            </MyTypography>{" "}
            ในการแก้ไขคำสั่งซื้อ
          </MyTypography>
        );
        setOpenError(true);
      } else {
        setSuccessfully(TypeOfAddProd.UnSuccessfully);
      }
    });
  };

  const handleOpenConfirm = () => {
    setOpenConfirmOrder(true);
  };

  const submitOrder = () => {
    setSubmitOrderCall(submitOrderCall + 1);
  };

  const handleCloseConfirm = () => {
    setSubmitOrderCall(0);
    setDataModalConfirm({
      content: undefined,
      title: undefined,
      type: undefined
    });
    setOpenConfirmOrder(false);
    setValueConfirmHeader(null);
    setValueConfirmMaterial(null);
  };

  const onSubmitOrder = (value: any, type: TypeSubmit) => {
    switch (type) {
      case TypeSubmit.SUBMIT_HEADER:
        setValueConfirmHeader(value);
        break;
      case TypeSubmit.SUBMIT_MATERIAL:
        setValueConfirmMaterial(value);
        break;
    }
  };

  useEffect(() => {
    if (valueConfirmHeader?.error || valueConfirmMaterial?.error) {
      setOpenError(true);
    } else {
      if (valueConfirmHeader !== null) {
        setDataModalConfirm({
          type: TypeConfirm.SUBMIT,
          title: intl.formatMessage({
            defaultMessage: "บันทึกการแก้ไขคำสั่งซื้อ"
          }),
          content: intl.formatMessage({
            defaultMessage:
              "กรุณากด “ยืนยัน” เพื่อแก้ไขคำสั่งซื้อ หรือกด “ยกเลิก” เพื่อกลับไป"
          })
        });
        handleOpenConfirm();
      }
    }
  }, [valueConfirmHeader, valueConfirmMaterial]);

  const converValueInquiryToEnum = (value: string): InquiryMethodType => {
    if (value === DATA_CHOICE.EXPORT) {
      return InquiryMethodType.EXPORT;
    }
    if (value === InquiryMethodType.ASAP) {
      return InquiryMethodType.ASAP;
    }
  };

  const handleConfirmOrder = () => {
    if (dataModalConfirm.type === TypeConfirm.SUBMIT) {
      const listMaterialChange: EditOrderItemInput[] = [...listMaterial]
        .filter(item => !item.isDelete)
        .map(item => ({
          id: item.id ?? undefined,
          conditionGroup1: item.conditionGroup1 ?? undefined,
          quantity: item.quantity != null ? +item.quantity : undefined,
          weightUnit:
            item.weightUnit === "ตัน" ? "TON" : item.weightUnit ?? undefined,
          itemCatEo: item.itemCategory ?? undefined,
          plant: item.plant ?? undefined,
          refPiStock: item.refPiStock ?? undefined,
          requestDate: item.requestDate ?? undefined,
          route: item.route ?? undefined,
          deliveryTolUnder: item.deliveryTolUnlimited
            ? 0
            : item.deliveryTolUnder,
          deliveryTolOver: item.deliveryTolUnlimited ? 0 : item.deliveryTolOver,
          deliveryTolUnlimited: item.deliveryTolUnlimited,
          rollDiameter: item.rollDiameter ?? undefined,
          rollQuantity: item.noOfRoll ?? undefined,
          rollCoreDiameter: item.rollCoreDiameter ?? undefined,
          rollPerPallet: item.reamRollPerPallet ?? undefined,
          palletSize: item.palletSize ?? undefined,
          palletNo: item.palletNo ?? undefined,
          packageQuantity: item.noOfPackage ?? undefined,
          packingList: item.packingList ?? undefined,
          shippingPoint: item.shippingPoint ?? undefined,
          remark: undefined,
          shippingMark: item.remark ?? undefined,
          inquiryMethod:
            converValueInquiryToEnum(item.inquiryMethod) ||
            InquiryMethodType.EXPORT
        }));

      delete valueConfirmHeader.isRequestDateChange;
      delete valueConfirmHeader.isEtaChange;
      delete valueConfirmHeader.isEtdChange;
      const input: EditExportOrderInput = {
        orderHeader: { ...valueConfirmHeader },
        orderItems: listMaterialChange.length ? listMaterialChange : [],
        soNo: exportOrder?.exportOrderWithAllItemsBySoNo.eoNo
      };
      const inputFormat = {
        ...input,
        orderHeader: convertValueObjectToNull(
          input.orderHeader,
          undefined,
          "usage"
        )
      };

      setSubmitOrderCall(0);
      setValueConfirmHeader(null);
      setValueConfirmMaterial(null);
      handleCloseConfirm();
      setOpenDialogProcessing(true);

      SubmitExportOrder({
        variables: {
          input: {
            ...inputFormat
          }
        }
      });
    } else if (dataModalConfirm.type === TypeConfirm.CANCEL) {
      // navigate(changeOrderUrl);
      queryParams.delete("mode");
      history.goBack();
    } else if (dataModalConfirm.type === TypeConfirm.REVERT) {
      setOpenConfirmOrder(false);
      setDataModalConfirm({
        itemNo: undefined,
        type: undefined,
        title: undefined,
        content: undefined,
        okText: undefined,
        cancelText: undefined
      });
      revertItem({
        variables: {
          soNo: id,
          itemNo: dataModalConfirm.itemNo
        }
      }).then(response => {
        if (response?.data?.undoOrderLinesExport?.success) {
          refetchDataExport();
        } else {
          if (response?.data?.undoOrderLinesExport) {
            if (response?.data?.undoOrderLinesExport?.errors?.length) {
              let orderErrors = "";
              // eslint-disable-next-line chai-friendly/no-unused-expressions
              response?.data?.undoOrderLinesExport?.errors?.length &&
                response?.data?.undoOrderLinesExport?.errors?.forEach(
                  ({ message }) => {
                    orderErrors += `${message} \n`;
                  }
                );

              notify({
                status: "error",
                apiMessage: orderErrors
              });
            } else if (
              response?.data?.undoOrderLinesExport?.iPlanMessages?.length
            ) {
              const errorMessages = response?.data?.undoOrderLinesExport?.iPlanMessages.map(
                item => `${item.firstCode}${item.secondCode} - ${item.message}`
              );

              notify({
                status: "error",
                sourceSystem: "IPLAN",
                apiMessage: errorMessages.join("\n")
              });
            } else {
              const sapErrorOrders = response?.data?.undoOrderLinesExport?.sapOrderMessages?.map(
                ({ errorCode, errorMessage }) =>
                  `${errorCode || ""} - ${errorMessage}`
              );
              const sapErrorItems = response?.data?.undoOrderLinesExport?.sapItemMessages?.map(
                ({ itemNo, errorMessage, errorCode }) =>
                  `${itemNo || ""} ${errorCode || ""} - ${errorMessage}`
              );
              notify({
                status: "error",
                title: "Something went wrong",
                text: (
                  <>
                    <Box>
                      <b>Error SAP</b>
                    </Box>
                    <Box>{`${sapErrorOrders}  ${sapErrorItems}`}</Box>
                  </>
                )
              });
            }
          }
        }
      });
    } else {
      handleCloseConfirm();
    }
  };

  const { refetch: callCreditLimit } = useGetCreditLimitQuery({
    variables: {
      input: {
        contractNo: exportOrder?.exportOrderWithAllItemsBySoNo?.contractNo,
        salesOrgCode: exportOrder?.exportOrderWithAllItemsBySoNo?.salesOrg,
        soldToCode: getSoldToCode()
      }
    },
    skip: true
  });

  const handleCallCreditLimit = () => {
    callCreditLimit({
      input: {
        contractNo: exportOrder?.exportOrderWithAllItemsBySoNo?.contractNo,
        salesOrgCode: exportOrder?.exportOrderWithAllItemsBySoNo?.salesOrg,
        soldToCode: getSoldToCode()
      }
    }).then(({ data }) => {
      if (data?.getCreditLimit?.creditBlockStatus) {
        toggleCreditBlock();
        return;
      }
      setViewEditMode(ViewEditMode.EDIT);
      setCancelEditCall(0);
    });
  };

  const handleCallCreditLimitAddItem = () => {
    callCreditLimit({
      input: {
        contractNo: exportOrder?.exportOrderWithAllItemsBySoNo?.contractNo,
        salesOrgCode: exportOrder?.exportOrderWithAllItemsBySoNo?.salesOrg,
        soldToCode: getSoldToCode()
      }
    }).then(({ data }) => {
      if (data?.getCreditLimit?.creditBlockStatus) {
        toggleCreditBlock();
        return;
      }
      handleOpenDrawAdd();
    });
  };

  const handleChangeMode = () => {
    setTypeBlock(TypeBlock.BLOCK_EDIT);
    if (!isStaff) {
      callCreditLimit().then(res => {
        if (res?.data?.getCreditLimit?.creditBlockStatus && !isStaff) {
          toggleCloseCreateOrderError();
          return;
        }
        setViewEditMode(ViewEditMode.EDIT);
        setCancelEditCall(0);
      });
    } else {
      if (exportOrder?.exportOrderWithAllItemsBySoNo?.orderPartners) {
        const {
          partnerNo
        } = exportOrder.exportOrderWithAllItemsBySoNo.orderPartners.find(
          orderPartner => orderPartner.partnerRole === "AG"
        );
        callCustomerBlock({
          input: { soldToCode: partnerNo }
        }).then(({ data }) => {
          if (data?.getCustomerBlock?.customerBlock) {
            toggleCustomerBlock();
            setContentCustomerBlock(
              "Customer รายนี้ถูก Block ท่านต้องการแก้ไขรายการสั่งซื้อนี้?"
            );
            return;
          }
          handleCallCreditLimit();
        });
      }
    }
  };

  const handleCancelEdit = () => {
    if (viewEditMode === ViewEditMode.EDIT) {
      setIsOpenCancelEdit(true);
    }
  };

  const handleCancelCancelEdit = () => {
    setIsOpenCancelEdit(false);
  };
  const clearErrorOrders = () => {
    setErrorOrders([]); // Set errorOrders to an empty array
  };

  const handleConfirmCancelEdit = () => {
    clearErrorOrders();
    setIsOpenCancelEdit(false);
    setCancelEditCall(1);
    setViewEditMode(ViewEditMode.VIEW);
    queryParams.delete("mode");
    history.replace({
      search: queryParams.toString()
    });
  };

  const handleOpenDrawAdd = () => {
    setIsPopupOpen(true);
    setDrawKey(prev => prev + 1);
  };

  const checkCustomerAddItem = () => {
    if (
      dataCheckContractExpiredCompleteInvalid
        ?.checkContractExpiredCompleteInvalid?.isInvalid
    ) {
      setIsOpenInvalidOrderError(true);
      return;
    }
    setTypeBlock(TypeBlock.BLOCK_ADD);
    if (exportOrder?.exportOrderWithAllItemsBySoNo?.orderPartners) {
      const {
        partnerNo
      } = exportOrder.exportOrderWithAllItemsBySoNo.orderPartners.find(
        orderPartner => orderPartner.partnerRole === "AG"
      );
      callCustomerBlock({
        input: { soldToCode: partnerNo }
      }).then(({ data }) => {
        if (data?.getCustomerBlock?.customerBlock) {
          toggleCustomerBlock();
          setContentCustomerBlock(
            "Customer รายนี้ถูก Block ท่านต้องการเพิ่มรายการสินค้าในคำสั่งซื้อนี้?"
          );
          return;
        }
        handleCallCreditLimitAddItem();
      });
    }
  };

  const [duplicateOrder] = useDuplicateOrderMutation({
    variables: {
      id
    },
    onCompleted: data => {
      if (data?.duplicateOrder?.order?.id) {
        navigate(orderCartPath(data?.duplicateOrder?.order?.id));
      } else if (
        data.duplicateOrder.errors[0].code ===
        ScgpExportErrorCode.PRODUCT_GROUP_ERROR
      ) {
        setOpenError(true);
        setPopUpContent(
          <MyTypography variant="body2" className={classes.popUpInlineBlock}>
            กรุณาเลือก{" "}
            <MyTypography
              variant="subtitle2"
              className={classes.popUpInlineBlock}
            >
              สินค้ากลุ่มเดียวกัน
            </MyTypography>{" "}
            ในการสร้างคำสั่งซื้อ
          </MyTypography>
        );
      }
    }
  });
  const handleDuplicateOrder = () => {
    duplicateOrder({
      variables: {
        id: exportOrder?.exportOrderWithAllItemsBySoNo?.eoNo || ""
      }
    });
  };

  const { refetch: callCreditLimitQuery } = useGetCreditLimitQuery({
    skip: true
  });

  const { refetch: callCustomerBlock } = useGetCustomerBlockQuery({
    skip: true
  });

  const handleConfirmCustomerBlock = () => {
    toggleCustomerBlock();
    if (typeBlock === TypeBlock.BLOCK_EDIT) {
      handleCallCreditLimit();
    } else if (typeBlock === TypeBlock.BLOCK_ADD) {
      handleCallCreditLimitAddItem();
    }
  };

  const handleSubmitOrder = () => {
    if (isStaff) {
      callCreditLimitQuery({
        input: {
          contractNo: exportOrder?.exportOrderWithAllItemsBySoNo?.contractNo,
          salesOrgCode: exportOrder?.exportOrderWithAllItemsBySoNo?.salesOrg,
          soldToCode: getSoldToCode()
        }
      }).then(res => {
        if (res?.data?.getCreditLimit?.creditBlockStatus) {
          toggleCloseCreateOrderError();
          return;
        }
        submitOrder();
      });
    } else {
      submitOrder();
    }
  };

  const [
    cancelItem,
    { loading: loadingCancelItem }
  ] = useCancelDeleteExportOrderMutation();

  const [
    revertItem,
    { loading: loadingRevertItem }
  ] = useUndoOrderLinesExportMutation();

  const onClickCancelItem = () => {
    setOpenDialogCancelDelete(true);
  };

  const onCloseDialogCancelDelete = () => {
    setOpenDialogCancelDelete(false);
  };

  const onConfirmCancelDelete = reason => {
    let reasonForReject: ChangeExportRejectReason;
    if (reason === "Cancel") {
      reasonForReject = ChangeExportRejectReason.CANCEL_93;
    } else if (reason === "Delete") {
      reasonForReject = ChangeExportRejectReason.DELETE;
    }
    cancelItem({
      variables: {
        soNo: id,
        reason: {
          reasonForReject
        },
        itemNos: listElements
      }
    }).then(response => {
      reset();
      setOpenDialogCancelDelete(false);
      if (response?.data?.cancelDeleteExportOrder) {
        const {
          sapOrderMessages,
          sapItemMessages,
          iPlanMessages
        } = response.data.cancelDeleteExportOrder;
        if (
          sapOrderMessages?.length ||
          iPlanMessages?.length ||
          sapItemMessages?.length
        ) {
          let messageError = "";
          let source = "";
          const sapError =
            sapItemMessages.length > 0
              ? sapItemMessages
              : sapOrderMessages || [];
          const iPlanError = iPlanMessages || [];
          if (sapError.length) {
            source = "SAP";

            const sapErrorOrders = sapOrderMessages?.map(
              ({ errorCode, errorMessage }) =>
                `${errorCode || ""} - ${errorMessage}`
            );

            const sapErrorItems = sapItemMessages?.map(
              ({ itemNo, errorMessage, errorCode }) =>
                `${itemNo || ""} ${errorCode || ""} - ${errorMessage}`
            );

            messageError = `${sapErrorOrders}  ${sapErrorItems}`;
          }
          if (iPlanError.length) {
            source = "iPlan";
            messageError = getIPlanMessagesCancelItem(iPlanError);
          }
          notify({
            status: "error",
            title: "Something went wrong",
            text: (
              <>
                {source && (
                  <Box>
                    <b>
                      Error
                      {`  ${source}`}
                    </b>
                  </Box>
                )}
                <Box>{messageError}</Box>
              </>
            )
          });
        } else {
          refetchDataExport();
        }
      }
    });
  };

  const handleRevertItem = itemNo => {
    setDataModalConfirm({
      itemNo,
      type: TypeConfirm.REVERT,
      content: intl.formatMessage({
        defaultMessage:
          "กรุณากด “ยืนยัน” เพื่อดำเนินการต่อ หรือกด “กลับไป” เพื่อปิดหน้าต่างนี้"
      }),
      title: intl.formatMessage({ defaultMessage: "ดึง Order item นี้กลับ" }),
      okText: intl.formatMessage({ defaultMessage: "ยืนยัน" }),
      cancelText: intl.formatMessage({ defaultMessage: "กลับไป" })
    });
    setOpenConfirmOrder(true);
  };

  // Disable button
  const getDisableAction = useMemo(
    () =>
      loadingChangeOrder ||
      loadingSubmitOrder ||
      loadingCancelItem ||
      loadingRevertItem ||
      loadingAddNewItem,
    [
      loadingChangeOrder,
      loadingSubmitOrder,
      loadingCancelItem,
      loadingRevertItem,
      loadingAddNewItem
    ]
  );

  const renderAgencyTab =
    exportOrder && exportOrder?.exportOrderWithAllItemsBySoNo ? (
      <AgencyTabContent
        dataExportOrder={exportOrder?.exportOrderWithAllItemsBySoNo}
      />
    ) : loadingChangeOrder ? (
      <Skeleton />
    ) : (
      ""
    );

  const renderHeaderOrderTab =
    exportOrder && exportOrder?.exportOrderWithAllItemsBySoNo ? (
      <div
        style={{
          display: activeTab === ChangeOrderTab.orderHeader ? "block" : "none"
        }}
        data-testid="header-tab-container"
      >
        <OrderHeaderTab
          dataExportOrder={exportOrder?.exportOrderWithAllItemsBySoNo}
          submitOrderCall={submitOrderCall}
          handleSubmitOrder={onSubmitOrder}
          viewEditMode={viewEditMode}
          setBillToInsteaded={setBillToInsteaded}
          setShipToInsteaded={setShipToInsteaded}
          dataOrderHeader={dataOrderHeader}
          setDataOrderHeader={setDataOrderHeader}
          netPrice={+priceData.netPrice}
          cancelEditCall={cancelEditCall}
        />
      </div>
    ) : loadingChangeOrder ? (
      <Skeleton />
    ) : (
      ""
    );

  const renderMaterialTab =
    exportOrder &&
    exportOrder?.exportOrderWithAllItemsBySoNo &&
    componentKey ? (
      viewEditMode === ViewEditMode.EDIT ? (
        <div
          style={{
            display:
              activeTab === ChangeOrderTab.materialItem ? "block" : "none"
          }}
          data-testid="material-item-tab-container-edit"
        >
          <MaterialItemTabEdit
            currency={priceData.currency || ""}
            key={`material_${componentKey}`}
            data={exportOrder?.exportOrderWithAllItemsBySoNo}
            onPreviousFirstPage={onFirstPage}
            onNextLastPage={onLastPage}
            disabled={
              loadingChangeOrder || loadingRevertItem || getDisableAction
            }
            latestPageItemNumber={listMaterial.length}
            onNextPage={onNextPage}
            onPreviousPage={onPrevPage}
            onRowClick={() => null}
            onSort={handleSort}
            totalCount={listMaterial.length || 0}
            sort={getSortParams(params)}
            onUpdateListSettings={updateListSettings}
            pageInfo={{
              hasNextPage: !disableNext(),
              hasPreviousPage: !disablePrev()
            }}
            bulkActions={bulkActions}
            settings={settings}
            submitOrderCall={submitOrderCall}
            handleSubmitOrder={onSubmitOrder}
            listMaterial={currentData()}
            setListMaterial={setListMaterial}
            listMaterialAll={listMaterial.filter(item => !item.isDelete)}
            handleRevertItem={handleRevertItem}
            isOrderInvalid={
              dataCheckContractExpiredCompleteInvalid
                ?.checkContractExpiredCompleteInvalid?.isInvalid
            }
          />
        </div>
      ) : (
        <div
          style={{
            display:
              activeTab === ChangeOrderTab.materialItem ? "block" : "none"
          }}
          data-testid="material-item-tab-container-detail"
        >
          <MaterialItemTabDetail
            currency={priceData.currency}
            key={`material_detail_${componentKey}`}
            onPreviousFirstPage={onFirstPage}
            onNextLastPage={onLastPage}
            disabled={loadingChangeOrder}
            latestPageItemNumber={listMaterial.length}
            onNextPage={onNextPage}
            onPreviousPage={onPrevPage}
            onRowClick={() => null}
            onSort={handleSort}
            totalCount={listMaterial.length}
            sort={getSortParams(params)}
            onUpdateListSettings={updateListSettings}
            pageInfo={{
              hasNextPage: !disableNext(),
              hasPreviousPage: !disablePrev()
            }}
            settings={settings}
            listMaterial={currentData()}
          />
        </div>
      )
    ) : null;

  const renderAddNewItemContainer = (
    <div
      className={cls({
        [classes.displayNone]: viewEditMode !== ViewEditMode.ADD
      })}
      data-testid="addNewItem-tab-container"
    >
      <AddNewItem
        currency={priceData.currency || ""}
        key={`material_${componentKey}`}
        data={exportOrder?.exportOrderWithAllItemsBySoNo}
        onPreviousFirstPage={onFirstPage}
        onNextLastPage={onLastPage}
        disabled={loadingChangeOrder}
        latestPageItemNumber={listMaterial.length}
        onNextPage={onNextPage}
        onPreviousPage={onPrevPage}
        onRowClick={() => null}
        onSort={handleSort}
        totalCount={listMaterial.length || 0}
        sort={getSortParams(params)}
        onUpdateListSettings={updateListSettings}
        pageInfo={{
          hasNextPage: !disableNext(),
          hasPreviousPage: !disablePrev()
        }}
        bulkActions={bulkActions}
        settings={settings}
        submitOrderCall={addItemSubmited}
        handleSubmitOrder={handleUpdateNewItem}
        listMaterial={currentData()}
        setListMaterial={setListMaterial}
        listMaterialAll={listMaterial.filter(item => !item.isDelete)}
      />
    </div>
  );
  const isFlagR5 = !!currentData().find(item => item.flagR5);
  // Loading system
  useEffect(() => {
    const loading =
      loadingChangeOrder ||
      loadingSubmitOrder ||
      loadingCancelItem ||
      loadingAddNewItem ||
      loadingRevertItem;
    dispatchAppState({
      payload: {
        value: loading
      },
      type: "displayLoader"
    });
  }, [
    loadingChangeOrder,
    loadingSubmitOrder,
    loadingCancelItem,
    loadingAddNewItem,
    loadingRevertItem
  ]);

  const getDisableDataChange = useMemo(() => {
    const disableChangeOrder = isEqual(dataOrderHeader, dataOrderHeaderRoot);
    const listMaterialChange = listMaterial.filter(
      item => item.isChange || item.isAddNew || item.isDelete
    );
    const disableChangeMaterial = listMaterialChange.length === 0;
    return disableChangeOrder && disableChangeMaterial;
  }, [dataOrderHeader, listMaterial]);

  const onCloseOrderProcessError = () => {
    setOrderProcessErrorDialog(false);
  };

  const getSoldToText = () => {
    let _soldToText = "";
    // eslint-disable-next-line chai-friendly/no-unused-expressions
    exportOrder?.exportOrderWithAllItemsBySoNo?.orderPartners?.forEach(
      orderPartner => {
        if (orderPartner?.partnerRole === "AG") {
          _soldToText = `${orderPartner?.partnerNo}-${orderPartner?.address[0].name}`;
        }
      }
    );
    return _soldToText;
  };

  const getShipToPartyName = () => {
    const _shipToPartyName = exportOrder?.exportOrderWithAllItemsBySoNo?.orderPartners?.find(
      item => item?.partnerRole === "WE" && item?.itemNo === "000000"
    );
    return `${_shipToPartyName?.partnerNo} - ${_shipToPartyName?.address[0]?.name}\n${_shipToPartyName?.address[0]?.street}, ${_shipToPartyName?.address[0]?.district}, ${_shipToPartyName?.address[0]?.city}`;
  };

  const getBillToPartyName = () => {
    const _billToPartyName = exportOrder?.exportOrderWithAllItemsBySoNo?.orderPartners?.find(
      item => item?.partnerRole === "RE"
    );
    return `${_billToPartyName?.partnerNo} - ${_billToPartyName?.address[0]?.name}`;
  };

  if (orderProcessStatus === OrderProcessStatus.timeOut) {
    return (
      <TimeOutPage
        timeOutText={
          <>
            <MyTypography variant={"body2"}>
              กรุณาตรวจสอบผลการแก้ไขคำสั่งซื้อที่เมนู Search Order/List of Sales
              Order
            </MyTypography>
          </>
        }
      />
    );
  }

  return (
    <>
      <Container className={classes.boxContainer}>
        {!fullScreen ? (
          <>
            <div className={classes.flex}>
              <PageHeader
                className={classes.pageHeader}
                title={getTitle()}
              ></PageHeader>
              <MyTypography variant={"body1"} className={classes.subTitle}>
                <b>EO No.</b>&nbsp;
                {exportOrder?.exportOrderWithAllItemsBySoNo?.eoNo}
              </MyTypography>
            </div>
            <AppHeader onBack={handleBack}>
              <MyTypography variant="body3">
                {intl.formatMessage({ defaultMessage: "กลับไป" })}
              </MyTypography>
            </AppHeader>
            <TabContainer>
              <div className={classes.tabBox}>
                {viewEditMode === ViewEditMode.ADD ? (
                  <AddNewItemTab
                    testId="add-new-item-tab"
                    isActive
                    changeTab={onTabClick}
                  >
                    <MyTypography variant="h6" className={classes.tab}>
                      {intl.formatMessage({
                        defaultMessage: "Order Item",
                        description: "subtitle"
                      })}
                    </MyTypography>
                  </AddNewItemTab>
                ) : (
                  <>
                    <AgencyTab
                      testId="agency-tab"
                      isActive={activeTab === ChangeOrderTab.agency}
                      changeTab={onTabClick}
                    >
                      <MyTypography variant="subtitle1" className={classes.tab}>
                        {intl.formatMessage({
                          defaultMessage: "Initial",
                          description: "subtitle"
                        })}
                      </MyTypography>
                    </AgencyTab>
                    <HeaderTab
                      testId="header-tab"
                      isActive={activeTab === ChangeOrderTab.orderHeader}
                      changeTab={onTabClick}
                    >
                      <MyTypography variant="subtitle1" className={classes.tab}>
                        {intl.formatMessage({
                          defaultMessage: "Order Header",
                          description: "subtitle"
                        })}
                      </MyTypography>
                    </HeaderTab>
                    <MaterialTab
                      testId="material-item-tab"
                      isActive={activeTab === ChangeOrderTab.materialItem}
                      changeTab={onTabClick}
                    >
                      <MyTypography variant="subtitle1" className={classes.tab}>
                        {intl.formatMessage({
                          defaultMessage: "Material Item",
                          description: "subtitle"
                        })}
                      </MyTypography>
                    </MaterialTab>
                  </>
                )}
              </div>
            </TabContainer>
          </>
        ) : (
          ""
        )}

        {!fullScreen ? (
          <Grid
            container
            spacing={2}
            className={classes.boxInfo}
            data-testid="order-info"
          >
            <Grid item xs={12} md={5}>
              <Grid container spacing={2} alignItems={"center"}>
                <Grid item md={2}>
                  <MyTypography variant={"subtitle3"}>PI No.</MyTypography>
                </Grid>
                <Grid item md={10}>
                  <MyTypography
                    variant={"subtitle1"}
                    className={classes.SoNo}
                    data-testid="piNo"
                  >
                    {exportOrder?.exportOrderWithAllItemsBySoNo?.contractNo}
                  </MyTypography>
                </Grid>
                <Grid item md={2}>
                  <MyTypography variant={"subtitle3"}>EO No.</MyTypography>
                </Grid>
                <Grid item md={10}>
                  <MyTypography variant={"body3"} data-testid="eoNo">
                    {exportOrder?.exportOrderWithAllItemsBySoNo?.eoNo}
                  </MyTypography>
                </Grid>

                <Grid item md={2}>
                  <MyTypography variant={"subtitle3"}>
                    Sold-to Party
                  </MyTypography>
                </Grid>
                <Grid item md={10}>
                  <MyTypography variant={"body3"} data-testid="soldToParty">
                    {getSoldToText()}
                  </MyTypography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={5}>
              <Grid container spacing={2} alignItems={"center"}>
                <Grid item md={3}>
                  <MyTypography variant={"subtitle3"}>PO No.</MyTypography>
                </Grid>
                <Grid item md={9}>
                  <MyTypography variant={"body3"} data-testid="poNo">
                    {exportOrder?.exportOrderWithAllItemsBySoNo?.poNo}
                  </MyTypography>
                </Grid>
                <Grid item md={3}>
                  <MyTypography variant={"subtitle3"}>
                    Ship-to Party
                  </MyTypography>
                </Grid>
                <Grid item md={9}>
                  <MyTypography variant={"body3"} data-testid="shipToParty">
                    {shipToInsteaded.split("\n")[0] ||
                      getShipToPartyName()?.split("\n")[0]}
                  </MyTypography>
                </Grid>
                <Grid item md={3}>
                  <MyTypography variant={"subtitle3"}>
                    Bill-to Party
                  </MyTypography>
                </Grid>
                <Grid item md={9}>
                  <MyTypography variant={"body3"} data-testid="billToParty">
                    {billToInsteaded.split("\n")[0] ||
                      getBillToPartyName()?.split("\n")[0]}
                  </MyTypography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={2}>
              <Grid container spacing={1}>
                <Grid item md={6}>
                  <MyTypography
                    variant={"subtitle3"}
                    className={classes.alignRight}
                  >
                    eOrdering Status
                  </MyTypography>
                </Grid>
                <Grid item md={6}>
                  <MyTypography
                    variant={"body3"}
                    className={cls(classes.alignRight, {
                      [classes.textRed]:
                        exportOrder?.exportOrderWithAllItemsBySoNo
                          ?.orderStatus === "Cancelled"
                    })}
                    data-testid="orderStatus"
                  >
                    {exportOrder?.exportOrderWithAllItemsBySoNo?.orderStatus}
                  </MyTypography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          ""
        )}

        {activeTab === ChangeOrderTab.agency &&
        viewEditMode !== ViewEditMode.ADD
          ? renderAgencyTab
          : ""}
        {viewEditMode !== ViewEditMode.ADD && renderHeaderOrderTab}
        {viewEditMode !== ViewEditMode.ADD && renderMaterialTab}
        {viewEditMode === ViewEditMode.ADD && renderAddNewItemContainer}

        {!fullScreen && (
          <ChangeOrderFooter
            isFlagR5={isFlagR5}
            onOrder={handleSubmitOrder}
            taxPercent={
              exportOrder?.exportOrderWithAllItemsBySoNo?.taxPercent || 0
            }
            orderStatus={
              exportOrder?.exportOrderWithAllItemsBySoNo?.orderStatus
            }
            priceData={priceData}
            disabled={getDisableAction || getDisableDataChange}
            disabledAddMore={getDisableAction}
            // disabledUpdate={!listMaterial.length}
            disabledUpdate={false}
            onOpenAtpCtp={handleClickAtpCtp}
            hasValidationError={null}
            setOpenCancelAddNewItem={setOpenCancelAddNewItem}
            setOpenConfirmAddNewItem={setOpenConfirmAddNewItem}
            activeTab={activeTab}
            bulkActions={bulkActions}
            onNextTab={onTabClick}
            onPreviousTab={onTabClick}
            onPopup={checkCustomerAddItem}
            onChangeMode={handleChangeMode}
            viewEditMode={viewEditMode}
            onDuplicate={handleDuplicateOrder}
            onCancelItem={onClickCancelItem}
            handleCancelEdit={handleCancelEdit}
          />
        )}

        <DrawAddProduct
          key={drawKey}
          open={isPopupOpen}
          onClose={handleClosePopup}
          contractId={exportOrder?.exportOrderWithAllItemsBySoNo?.contractNo}
          data={{
            piNo: exportOrder?.exportOrderWithAllItemsBySoNo?.contractNo,
            soldTo: `${getSoldToCode()}-${getSoldToName()}`
          }}
          handleSubmit={handleAddProductToExport}
          title={intl.formatMessage({ defaultMessage: "Add to order" })}
          listProductAdded={listMaterial}
          addType={DrawAddExportType.CHANGEORDER}
        />

        <DialogConfirmChangeOrder
          onClose={handleCloseConfirm}
          open={openConfirmOrder}
          onOk={handleConfirmOrder}
          title={dataModalConfirm.title}
          content={dataModalConfirm.content}
          okText={dataModalConfirm.okText}
          cancelText={dataModalConfirm.cancelText}
        />

        <OrderProcessError
          open={orderProcessErrorDialog}
          onClose={onCloseOrderProcessError}
          errorCode={orderProcessError}
        />
      </Container>
      {isSuccessfully && (
        <SnackbarAlert
          severity={isSuccessfully}
          open={!!isSuccessfully}
          onClose={() => setSuccessfully(null)}
          verticalCenter={true}
          anchorOrigin={{ horizontal: "center", vertical: "top" }}
          data-testid="snack-bar"
        >
          <div className={classes.snackHeadTitle}>
            <MyTypography
              variant="subtitle2"
              style={{ color: "#ffffff", marginRight: "2px" }}
            >
              {intl.formatMessage({
                defaultMessage: "Added to order",
                description: "dialog header"
              })}
            </MyTypography>
            <MyTypography variant="body3" style={{ color: "#ffffff" }}>
              {isSuccessfully === "success"
                ? "เพิ่มสินค้าในคำสั่งซื้อสำเร็จ"
                : "เพิ่มสินค้าลงตะกร้าไม่สำเร็จ"}
            </MyTypography>
          </div>
        </SnackbarAlert>
      )}
      <Backdrop open={!!isSuccessfully} className={classes.backDrop} />
      <DialogSubmitOrder open={openDialogProcessing} onClose={() => null} />
      <DialogError
        onClose={() => {
          setOpenError(false);
          setPopUpContent(null);
        }}
        open={openError}
        body={popUpContent}
      />
      <DialogConfirm
        buttonClass={"defaultB"}
        title={"ยกเลิกแก้ไขคำสั่งซื้อ"}
        content={`"ยืนยัน" เพื่อยกเลิกเพิ่มรายการสินค้าทั้งหมด หรือกด "กลับไป" เพื่อปิดหน้าต่างนี้`}
        onCancel={handleCancelCancelEdit}
        onConfirm={handleConfirmCancelEdit}
        open={isOpenCancelEdit}
      />
      <DialogCreateOrderError
        onConfirm={() => {
          toggleCloseCreateOrderError();
          if (isStaff) {
            submitOrder();
          }
        }}
        open={openCreateOrderError}
        okText="ปิดหน้าต่าง"
        title={
          isStaff ? "ลูกค้ารายนี้ติด Credit Block" : "ไม่สามารถดำเนินการต่อได้"
        }
        content={
          isStaff ? (
            <MyTypography variant="body2" className={classes.inlineBlock}>
              เนื่องจากลูกค้ารายนี้ติด Credit Block กรุณาติดต่อฝ่ายสินเชื่อ
            </MyTypography>
          ) : (
            <span>
              <MyTypography variant="body2" className={classes.inlineBlock}>
                เนื่องจาก Customer Credit :
              </MyTypography>{" "}
              <MyTypography variant="subtitle2" className={classes.inlineBlock}>
                Credit Blocked
              </MyTypography>
            </span>
          )
        }
      />
      <DialogError
        title="ไม่สามารถดำเนินการได้"
        width={372}
        body={
          <>
            <MyTypography component={"span"} variant="body2">
              ไอเทมรายการ
            </MyTypography>
            <MyTypography component={"span"} variant="body2">
              {`\t ${itemErrorsR5?.length &&
                itemErrorsR5
                  .sort((itemA, itemB) => Number(itemA) - Number(itemB))
                  .join(", ")} \t`}
            </MyTypography>
            <MyTypography component={"span"} variant="body2">
              ไม่สามารถดำเนินการตรวจสอบ ATP/CTP ได้ เนื่องจากติด R5
            </MyTypography>
          </>
        }
        confirmText={"ปิดหน้าต่าง"}
        onClose={() => {
          setOpenR5ErrorPopup(false);
        }}
        open={openR5ErrorPopup}
      />
      {openDrawATP && (
        <AtpCtpDialog
          displayByOrderNo
          open={openDrawATP}
          refetchData={refetchDataExport}
          isDisapearItem={isDisapearItem}
          handleSubmit={acceptAtpItem}
          listAtpCtp={dataDrawATP}
          orderId={id}
          onClose={() => {
            setOpenDrawATP(false);
          }}
          loading={loadingAtpCtp}
        />
      )}
      <DialogError
        title="ไม่สามารถดำเนินการได้"
        width={372}
        testId="atpctp-gidate-error-modal"
        body={
          <>
            <MyTypography component={"span"} variant="body2">
              ไอเทมรายการ
            </MyTypography>
            <MyTypography component={"span"} variant="body2">
              {`\t ${itemErrors?.length &&
                itemErrors
                  .sort((itemA, itemB) => Number(itemA) - Number(itemB))
                  .join(", ")} \t`}
            </MyTypography>
            <MyTypography component={"span"} variant="body2">
              ไม่สามารถดำเนินการตรวจสอบ ATP/CTP ได้
              เนื่องจากได้มีการส่งสินค้าแล้ว
            </MyTypography>
          </>
        }
        confirmText={"ปิดหน้าต่าง"}
        onClose={() => {
          setOpenGLDateErrorPopup(false);
        }}
        open={openGLDateErrorPopup}
      />
      <DialogError
        title="ไม่สามารถดำเนินการได้"
        width={372}
        testId="atpctp-status-error-modal"
        body={
          <>
            <MyTypography component={"span"} variant="body2">
              ไอเทม
            </MyTypography>
            <MyTypography component={"span"} variant="body2">
              {`\t ${itemErrors?.length &&
                itemErrors
                  .sort((itemA, itemB) => Number(itemA) - Number(itemB))
                  .join(", ")} \t`}
            </MyTypography>
            <MyTypography component={"span"} variant="body2">
              ไม่สามารถดำเนินการตรวจสอบ ATP/CTP ได้ เนื่องจากอยู่ระหว่างการผลิต
              หรือ ผลิตเสร็จแล้ว
            </MyTypography>
          </>
        }
        confirmText={"ปิดหน้าต่าง"}
        onClose={() => {
          setOpenDialogAtpCtpError(false);
        }}
        open={openDialogAtpCtpError}
      />
      <CustomerBlockDialog
        content={contentCustomerBlock}
        open={openCustomerBlock}
        onConfirm={handleConfirmCustomerBlock}
        isViewOrder
        onClose={toggleCustomerBlock}
      />
      <CreditBlockDialog
        content="ไม่สามารถทำรายการได้ เนื่องจากลูกค้าติด
        (ฺCredit Block) กรุณาติดต่อเจ้าหน้าที่สินเชื่อ"
        open={openCreditBlock}
        onClose={toggleCreditBlock}
      />
      <DialogConfirmCancelItem
        onCancel={onCloseDialogCancelDelete}
        onConfirm={onConfirmCancelDelete}
        open={openDialogCancelDelete}
        loading={loadingCancelItem}
      />
      <DialogConfirm
        buttonClass={"defaultB"}
        title={"ยกเลิกเพิ่มรายการสินค้า"}
        content={
          'กรุณากด "ยืนยัน" เพื่อยกเลิกเพิ่มรายการสินค้าทั้งหมด หรือกด "กลับไป" เพื่อปิดหน้าต่างนี้'
        }
        cancelText="กลับไป"
        okText="ยืนยัน"
        onCancel={() => setOpenCancelAddNewItem(false)}
        onConfirm={handleCancelAddNewItem}
        open={openCancelAddNewItem}
      />
      <DialogConfirm
        titleClass={classes.titleGradient}
        buttonClass={"gradient"}
        title={"บันทึกคำสั่งซื้อ"}
        content={
          'กรุณากด "ยืนยัน" เพื่อบันทึกคําสั่งชื่อ หรือกด กลับไป เพื่อปิดหน้าต่างนี้'
        }
        onCancel={() => setOpenConfirmAddNewItem(false)}
        onConfirm={handleSubmitAddNewItem}
        open={openConfirmAddNewItem}
      />
      <InvalidModal
        title="ไม่สามารถเพิ่มรายการสินค้าได้"
        content="เนื่องจาก Contract Invalid/Completed"
        buttonContent="ปิดหน้าต่าง"
        open={isOpenInvalidOrderError}
        onClose={() => {
          setIsOpenInvalidOrderError(false);
        }}
      />

      <DialogConfirmError
        open={dialogError}
        onConfirm={() => setDialogError(false)}
        onCancel={() => setDialogError(false)}
        errorSource={errorSource}
        errorOrders={errorOrders}
        errorItems={errorItems}
      />
      <OrderBeingProcessError
        open={!!beingProcessMsg}
        onClose={() => setBeingProcessMsg("")}
        errorMessage={beingProcessMsg}
      />
      <DialogProcessing
        open={
          loadingChangeOrder ||
          loadingCancelItem ||
          loadingRevertItem ||
          loadingAtpCtp
        }
        description={"ระบบกำลังประมวลผล กรุณารอสักครู่"}
      />
    </>
  );
};

export default ViewEditOrdersView;
